import React from 'react';
import { COLORS, RIGHT_INDENTS } from '@constants';
import { Icon, Tag, Typography } from '@ui';
import { StyledLeft, StyledWrapper } from './styled';

const Header = ({ itemKey, title, status, isOpen }) => {
    const iconsMap = {
        'customer-service': <Icon.MobilePhoneIcon />,
        'payment-info': <Icon.CreditCardIcon />,
        'contact-info': <Icon.ContactCenterIcon />,
        'integrations-info': <Icon.PuzzleIcon />
    };

    const tagColorMap = {
        Incomplete: COLORS.$tartRed,
        Finished: COLORS.$robinBlue,
        Optional: COLORS.$gray40Black,
        'Pending...': COLORS.$alert
    };

    const getTagColor = () => {
        return tagColorMap[status] || COLORS.$white;
    };

    return (
        <StyledWrapper>
            <StyledLeft>
                <Icon
                    size='56px'
                    color={COLORS.$gray60Black}
                    component={() => iconsMap[itemKey]}
                    style={RIGHT_INDENTS.M}
                />
                <Typography.Text data-e2e={`launchcampaign-${itemKey}_title`} type='badgeMedium'>
                    {title}
                </Typography.Text>
                {isOpen ? (
                    <Icon.ArrowChevronUpIcon
                        width='16'
                        height='16'
                        color={COLORS.$gray40Black}
                        strokeWidth='4'
                        style={{ marginLeft: '8px' }}
                    />
                ) : (
                    <Icon.ArrowChevronDownIcon
                        width='16'
                        height='16'
                        color={COLORS.$gray40Black}
                        strokeWidth='4'
                        style={{ marginLeft: '8px' }}
                    />
                )}
            </StyledLeft>
            {typeof status === 'object' ? (
                status
            ) : (
                <Tag data-e2e={`launchcampaign-${itemKey}_status`} color={getTagColor()}>
                    {status}
                </Tag>
            )}
        </StyledWrapper>
    );
};

export default Header;
